import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { reset } from 'redux-form';
import List from './List';
import Filter from './Filter';
import { loadCancellationCreditNotesReport, exportCancellationCreditNotes, settleRefund, SETTLE_REFUND_REQUEST, SETTLE_REFUND_SUCCESS, SETTLE_REFUND_FAILURE } from './actions';
import { initialize } from 'redux-form';
import SettleRefundDialog from './SettleRefundDialog';
import authUtils from '../../../auth/utils';

class CancellationCreditNotesReport extends Component {

	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.showSettleDialog = this.showSettleDialog.bind(this);
		this.hideSettleDialog = this.hideSettleDialog.bind(this);
		this.handleSettleConfirm = this.handleSettleConfirm.bind(this);
		this.state = {
			refundToSettle: null
		};
	}

	showSettleDialog(refund) {
		this.setState({ refundToSettle: refund });
	}

	hideSettleDialog() {
		this.setState({ refundToSettle: null });
	}

	handleSettleConfirm(values) {
		this.props.settleRefund(this.state.refundToSettle.id, values, this.hideSettleDialog);
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;

		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
	}

	handleFilterSubmit(options) {
		const { exportFormat, ...filter } = options;
		const { sortKey, sortDirection, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
		if (exportFormat)
			this.exportData(filter, exportFormat);
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		const { loadReport } = this.props;
		loadReport({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	exportData(filter, exportFormat) {
		this.props.exportCancellationCreditNotes(exportFormat, filter);
	}

	render() {
		const { data, requireChildSchool, canSettle } = this.props;

		return (
			<div>
				<SettleRefundDialog show={!!this.state.refundToSettle}
					refund={this.state.refundToSettle}
					block={SETTLE_REFUND_REQUEST}
					unblock={[SETTLE_REFUND_SUCCESS, SETTLE_REFUND_FAILURE]}
					onConfirm={this.handleSettleConfirm}
					onCancel={this.hideSettleDialog} />
				<Filter
					onSubmit={this.handleFilterSubmit}
					loading={this.props.pagination.loading || this.props.export.loading}
				/>
				<List
					data={data}
					onFetchData={this.handleListEvent}
					requireChildSchool={requireChildSchool}
					canSettle={canSettle}
					onSettle={this.showSettleDialog}
					{...this.props.pagination}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	
	const {
		pagination,
		exports,
		entities: { cancellationCreditNotesReport },
		configuration: { franchisor },
		auth: { currentUser }
	} = state;

	const cancellationCreditNotesReportPagination = pagination.cancellationCreditNotesReport.all || { ids: [], pageNumber: 1, pageSize: 10 };
	const cancellationCreditNotesExport = exports.cancellationCreditNotes.all || {};

	return {
		data: cancellationCreditNotesReportPagination.ids.map(id => cancellationCreditNotesReport[id]),
		pagination: cancellationCreditNotesReportPagination,
		export: cancellationCreditNotesExport,
		requireChildSchool: franchisor.requireChildSchool,
		canSettle: authUtils.hasPermission(currentUser, 'MarkAsPaid')
	};
};

const mapDispatchToProps = {
	loadReport: loadCancellationCreditNotesReport,
	exportCancellationCreditNotes,
	settleRefund,
	resetFilter: () => reset('cancellationCreditNoteFilter'),
	initializeFilter: (data, fields) => initialize('cancellationCreditNoteFilter', data, fields)
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CancellationCreditNotesReport));